import { render, staticRenderFns } from "./ApiTokenManager.vue?vue&type=template&id=cdb4f07a&"
import script from "./ApiTokenManager.vue?vue&type=script&lang=js&"
export * from "./ApiTokenManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports